module.exports = __webpack_public_path__ + "img/university_thumbnail.fdf95245.jpg";